import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { goToSection } from '../Utils/pageNavigationHelpers';

const Headings = ({ headings, activeId, isShown, setIsShown, headingRefs }) => {
    function toggleIsShown(id) {
        setIsShown(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    }

    return (
        <>
            { headings.map((heading, index) => (
                heading.items.length > 0 ?
                (  <>
                    <button key={heading.id} onClick={() => {toggleIsShown(heading.id)}} className={`navigation__item navigation__item--main ${isShown[heading.id] ? 'shown' : 'hidden'}`}>{heading.title}</button>
                    { isShown[heading.id] && (
                        <>
                            { heading.items.map((child) => (
                                <Link key={child.id} className={`navigation__item navigation__item--sub ${child.id === activeId ? "active" : ""}`} to={`#${child.id}`} onClick={() => {goToSection(headingRefs[child.id])}}>
                                    {child.title}
                                </Link>
                            ))}
                        </>
                    )}
                </> ) :
                ( heading.items.length === 0 && <>
                    <Link key={heading.id} className={`navigation__item navigation__item ${heading.id === activeId ? "active" : ""}`} to={`#${heading.id}`}>
                        {heading.title}
                    </Link>
                </> )
            ))}
        </>
    )
};

function useHeadingsData() {
    const [nestedHeadings, setNestedHeadings] = useState([]);
  
    useEffect(() => {
        const headingElements = Array.from(
            document.querySelectorAll("h2, h3")
        );

        const newNestedHeadings = getNestedHeadings(headingElements);
        setNestedHeadings(newNestedHeadings);
    }, []);
  
    return { nestedHeadings };
};
  
function getNestedHeadings(headingElements) {
    const nestedHeadings = [];
  
    headingElements.forEach((heading, index) => {
        const { innerText: title, id } = heading;
    
        if (heading.nodeName === "H2") {
            nestedHeadings.push({ id, title, items: [] });
        } else if (heading.nodeName === "H3" && nestedHeadings.length > 0) {
            nestedHeadings[nestedHeadings.length - 1].items.push({ id, title });
        }
    });
  
    return nestedHeadings;
};
  
const useIntersectionObserver = (setActiveId) => {
    const headingElementsRef = useRef({});
    useEffect(() => {
        const callback = (headings) => {
            headingElementsRef.current = headings.reduce((map, headingElement) => {
                map[headingElement.target.id] = headingElement;
                return map;
            }, headingElementsRef.current);
    
            const visibleHeadings = [];
            Object.keys(headingElementsRef.current).forEach((key) => {
                const headingElement = headingElementsRef.current[key];
                if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
            });
    
            const getIndexFromId = (id) =>
            headingElements.findIndex((heading) => heading.id === id);
    
            if (visibleHeadings.length === 1) {
                setActiveId(visibleHeadings[0].target.id);
            } else if (visibleHeadings.length > 1) {
                const sortedVisibleHeadings = visibleHeadings.sort(
                    (a, b) => getIndexFromId(a.target.id) > getIndexFromId(b.target.id)
                );
        
                setActiveId(sortedVisibleHeadings[0].target.id);
            }
        };
    
        const observer = new IntersectionObserver(callback, { root: document.querySelector("iframe") });
    
        const headingElements = Array.from(document.querySelectorAll("h2, h3"));
    
        headingElements.forEach((element) => observer.observe(element));
    
        return () => observer.disconnect();
    }, [setActiveId]);
};

export default function InnerNavigation(props) {
    const [activeId, setActiveId] = useState();
    const { nestedHeadings } = useHeadingsData();
    useIntersectionObserver(setActiveId);
  
    return (
        <nav>
            <Headings
                headings={nestedHeadings}
                activeId={activeId}
                isShown={props.isShown}
                setIsShown={props.setIsShown}
                headingRefs={props.headingRefs} />
        </nav>
    );
};
